import React, { PropsWithChildren } from 'react';

export function ImageList({ children }: PropsWithChildren<any>) {
  // This list will never be empty because images is always present
  return <ul className="image-gallery__list">{children}</ul>;
}
